
import { useBackLayer } from "./useBackLayer";

export function useSheetDismiss(
  open: boolean,
  onClose: () => void,
  rearmAfterBack = false,
): { requestClose: () => void } {
  return useBackLayer({
    open,
    layerKey: "sheet",
    kind: "sheet",
    onBack: onClose,
    cleanupOnProgrammaticClose: true,
    rearmAfterBack,
  });
}
